import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export enum BadgeType {
  Alert,
  Warning,
  LiteWarning,
  Info,
  White,
  Gray,
  TicketsNavigation,
}

export enum BadgeSize {
  Normal,
  Huge,
  TicketsNavigation,
}

interface IProps {
  type: BadgeType;
  size?: BadgeSize;
  title?: string;
  children?: React.ReactNode;
}

const badgeSizes = {
  [BadgeSize.Normal]: "16px",
  [BadgeSize.TicketsNavigation]: "16px",
  [BadgeSize.Huge]: "48px",
};
const getBadgeSize = (size: BadgeSize): string => badgeSizes[size];

const badgeFontSizes = {
  [BadgeSize.Normal]: "10px",
  [BadgeSize.Huge]: "32px",
  [BadgeSize.TicketsNavigation]: "13px",
};
const getBadgeFontSize = (size: BadgeSize): string => badgeFontSizes[size];

const badgeBackgrounds = {
  [BadgeType.Alert]: withVar(DesignToken.SurfaceAccentEmphasisLowNegative),
  [BadgeType.Warning]: withVar(DesignToken.SurfaceAccentEmphasisLowWarning),
  [BadgeType.LiteWarning]: withVar(DesignToken.SurfaceInvertPrimary),
  [BadgeType.White]: withVar(DesignToken.SurfacePrimaryDefault),
  [BadgeType.Gray]: withVar(DesignToken.SurfaceTertiaryDefault),
  [BadgeType.TicketsNavigation]: withVar(DesignToken.SurfaceTertiaryDefault),
};

const getBadgeBackground = (type: BadgeType): string =>
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  badgeBackgrounds[type] || withVar(DesignToken.SurfaceAccentEmphasisLowInfo);

const badgeFontColors = {
  [BadgeType.White]: withVar(DesignToken.ContentBasicSecondary),
  [BadgeType.Gray]: withVar(DesignToken.ContentBasicSecondary),
  [BadgeType.TicketsNavigation]: withVar(DesignToken.ContentBasicSecondary),
};

const badgeFontWeights = {
  [BadgeSize.TicketsNavigation]: "400",
};

const getBadgeFontColor = (type: BadgeType): string =>
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  badgeFontColors[type] || withVar(DesignToken.ContentInvertPrimary);

// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const getBadgeFontWeight = (size: BadgeSize): string => badgeFontWeights[size] || "600";

type IStyledBadge = IProps;

const StyledBadge = styled.div<IStyledBadge>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => getBadgeSize(props.size)
  };
  height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => getBadgeSize(props.size)
  };
  line-height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => getBadgeSize(props.size)
  };
  padding: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.size === BadgeSize.TicketsNavigation ? "2px 10px" : "2px 4px")
  };
  box-sizing: border-box;
  border-radius: 50px;
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => getBadgeBackground(props.type)
  };

  span {
    font-size: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => getBadgeFontSize(props.size)
    };
    font-weight: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => getBadgeFontWeight(props.size)
    };
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => getBadgeFontColor(props.type)
    };
  }
`;

export const Badge: React.FC<IProps> = ({ children, title, ...props }) => (
  <StyledBadge title={title} {...props}>
    <span>{children}</span>
  </StyledBadge>
);

Badge.defaultProps = {
  size: BadgeSize.Normal,
};
